import React from 'react'

function CustBorderRad() {
  return (
    <>
    <h2>Custom Border Radius</h2>
    <br/>
    <p className='p-doc'>value of border radius in px</p>
    <code>cust-br-[value in integer]</code>
    </>
  )
}

export default CustBorderRad